{
    "Title": "Warteschlangen verwalten",
    "ManageQueuesDescriptionTitle": "Beschreibung",
    "ManageQueuesCQConfigurationsTitle": "CQ-Konfigurationen",
    "ManageQueuesResourceAccountsTitle": "Ressourcenkonten",
    "ManageQueuesMonitoringStatusTitle": "Überwachungsstatus",
    "ManageQueueFiltersTitle": "Filter",
    "ManageQueueCallMonitoringHistoric": "Historisch",
    "ManageQueueCallMonitoringRealTime": "Echtzeit",
    "ManageQueueCallMonitoringRealTimeForced": "Echtzeit (erzwungen)",
    "ManageQueueCallMonitoringUnknown": "Unbekannt",
    "ManageQueueCallCQConfigurationCompatible": "Kompatibel",
    "ManageQueueCallCQConfigurationIncompatible": "Unvereinbar",
    "ManageQueuesQueueFilterAll": "Alle Warteschlangen",
    "ManageQueuesFilterCompatible": "Kompatible Warteschlangen",
    "ManageQueuesFilterIncompatible": "Inkompatible Warteschlangen",
    "ManageQueue_DisableEnableRealtime_Confirm": "Bestätigen",
    "ManageQueue_DisableEnableRealtime_Cancel": "Stornieren",
    "ManageQueue_MonitorAllMessage": "Möchten Sie die Echtzeitüberwachung für alle Warteschlangen wirklich aktivieren?",
    "ManageQueue_UnmonitorAllMessage": "Möchten Sie die Echtzeitüberwachung für alle Warteschlangen wirklich deaktivieren?",
    "ManageQueue_Loading_Monitoring_All": "Aktivieren der Echtzeitüberwachung für alle Warteschlangen",
    "ManageQueue_Loading_Unmonitoring_All": "Deaktivieren der Echtzeitüberwachung für alle Warteschlangen",
    "ManageQueue_Pending_Queue_Disabling": "Überwachung wird deaktiviert...",
    "ManageQueue_Pending_Queue_Enabling": "Überwachung wird aktiviert...",
    "ManageQueue_Disable_RT_Popper": "Deaktivieren Sie die Echtzeitüberwachung für alle Warteschlangen",
    "ManageQueue_Enable_RT_Popper": "Aktivieren Sie die Echtzeitüberwachung aller Warteschlangen",
    "ManageQueues_Not_Found_Error": "Es wurden keine Warteschlangen gefunden, die dieser Suche entsprechen",
    "NAME": "ManageQueues",
    "ManageQueues_Linkage_Title": "Verknüpfte Ressourcenkonten\/Sprach-Apps",
    "ManageQueues_Linkage_Help": "Klicken Sie auf „Hilfe“, um zu erfahren, wie Sie Ressourcenkonten erneut verknüpfen.",
    "ManageQueues_Linkage_Types_CallQueue": "Das Ressourcenkonto „**{}**“ wird für die Ausnahmebehandlung von „**{}**“ in der Anrufwarteschlange „**{}**“ verwendet.",
    "ManageQueues_Linkage_Types_AutoAttendant": "Das Ressourcenkonto „**{}**“ wird für die Option „**{}**“ von „**{}**“ im automatischen Telefonzentralendienst „**{}**“ verwendet.",
    "ManageQueues_Linkage_Types_Policy": "Das Ressourcenkonto „**{}**“ wird innerhalb der Richtlinie „**{}**“ vom Typ „**{}**“ verwendet.",
    "ManageQueues_Linkage_CallQueue_Exceptions_overflow": "Überlauf",
    "ManageQueues_Linkage_CallQueue_Exceptions_timeout": "Time-out",
    "ManageQueues_Linkage_CallQueue_Exceptions_noagent": "Kein Agent",
    "ManageQueues_Linkage_CallQueue_Exceptions_obo": "Im Namen von",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_businesshours": "Geschäftszeiten",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_afterhours": "Nach Feierabend",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_holiday": "Urlaub",
    "ManageQueues_Linkage_Policy_Types_teamssharedcallingroutingpolicy": "Gemeinsame Anrufroutingrichtlinie",
    "ManageQueues_Linkage_Policy_Types_teamsunassignednumbertreatment ": "Behandlung nicht zugewiesener Nummern",
    "ManageQueues_Linkage_Policy_Types_callinglineidentity": "Anruferidentität",
    "ManageQueues_Linkage_Options_automatic": "Umleiten",
    "ManageQueues_Linkage_Options_pound": "Pfund",
    "ManageQueues_Linkage_Options_star": "Stern",
    "ManageQueues_Linkage_NoInfo": "Keine Ressourcenkontoreferenzen für diese Warteschlange.",
    "ManageQueues_Incompatibility_Popup_Title": "Inkompatible Einstellungen",
    "ManageQueues_ExchangePermission_Error": "Für den TelSys-Auth-Benutzer wurden keine Administrator-\/Exchange-Berechtigungen gefunden. Gemeinsame Voicemails können nicht erstellt werden."
}